export * from 'src/app/@theme/layouts/menu/horizontal-menu/horizontal-menu.component';
export * from 'src/app/@theme/layouts/menu/horizontal-menu/horizontal-menu.module';
